import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'

export const vatRegex = /^[A-Z]{2,4}(?=.{2,12}$)[-_\s0-9]*(?:[a-z][-_\s0-9]*){0,2}$/i

export default (value: any, validators: string[]) => {
  const { t } = useI18n()

  const isBlurred = ref(false)

  const setBlurred = () => {
    isBlurred.value = true
  }
  const addErrorMessage = (message: string, errorMessages: string[]) => {
    return errorMessages.push(message)
  }

  const validateRequired = (value: any, errorMessages: string[]) => {
    if (!value.value || value.value === '')
      addErrorMessage(t('validation.required'), errorMessages)
  }

  const validateEmail = (value: any, errorMessages: string[]) => {
    if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value.value))
      addErrorMessage(t('validation.email'), errorMessages)
  }

  const validateVat = (value: any, errorMessages: string[]) => {
    if (!vatRegex.test(value.value))
      addErrorMessage(t('validation.vat_number'), errorMessages)
  }

  const validateMinLength = (value: any, errorMessages: string[], minLength: number) => {
    if (value?.value && value?.value?.length < minLength)
      addErrorMessage(t('validation.min_length', { length: minLength }), errorMessages)
  }

  const validateMaxLength = (value: any, errorMessages: string[], maxLength: number) => {
    if (value?.value && value?.value?.length > maxLength)
      addErrorMessage(t('validation.max_length', { length: maxLength }), errorMessages)
  }

  const validatePhone = (value: any, errorMessages: string[]) => {
    if (!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value.value))
      addErrorMessage(t('validation.phone'), errorMessages)
  }

  const validateZipcode = (value: any, errorMessages: string[], countryCode: string) => {
    if (countryCode === 'be') {
      if (value?.value?.length !== 4 || !Number.parseInt(value.value))
        addErrorMessage(t('validation.zipcode_be'), errorMessages)
    }
    else if (countryCode === 'lu') {
      if (value?.value?.length !== 4 || !Number.parseInt(value.value))
        addErrorMessage(t('validation.zipcode_be'), errorMessages)
    }
    else if (countryCode === 'nl') {
      const first4 = value?.value?.substring(0, 4)
      const last2 = value?.value?.substring(5, 7)
      const fifth = value?.value?.substring(4, 5)
      const last2short = value?.value?.substring(4, 6)
      const first4short = value?.value?.substring(0, 4)

      if ((value?.value?.length !== 7 || !Number.parseInt(first4) || !/^[aA-zZ][aA-zZ]$/.test(last2) || fifth !== ' ') && (value?.value?.length !== 6 || !Number.parseInt(first4short) || !/^[aA-zZ][aA-zZ]$/.test(last2short)))
        addErrorMessage(t('validation.zipcode_nl'), errorMessages)
    }
    else {
      if (value?.value?.length !== 5)
        addErrorMessage(t('validation.zipcode_other'), errorMessages)
    }
  }

  const validateAll = (value: any, validators: any, errorMessages: string[]) => {
    if (validators.value)
      validators = validators.value
    validators.forEach((validator: any) => {
      const splitValidator = validator.split(':')
      const validatorType = splitValidator[0]
      const validatorVariable = splitValidator[1]

      if (validatorType === 'required')
        validateRequired(value, errorMessages)
      if (validatorType === 'email')
        validateEmail(value, errorMessages)
      if (validatorType === 'phone')
        validatePhone(value, errorMessages)
      if (validatorType === 'minLength')
        validateMinLength(value, errorMessages, Number.parseInt(validatorVariable))
      if (validatorType === 'maxLength')
        validateMaxLength(value, errorMessages, Number.parseInt(validatorVariable))
      if (validatorType === 'zipcode')
        validateZipcode(value, errorMessages, validatorVariable)
      if (validatorType === 'vat')
        validateVat(value, errorMessages)
    })
  }

  const errorMessages = computed(() => {
    const validatedErrors: string[] = []
    if (isBlurred.value)
      validateAll(value, validators, validatedErrors)
    return validatedErrors
  })

  const isValid = computed(() => {
    const validatedErrors: string[] = []
    validateAll(value, validators, validatedErrors)
    return validatedErrors.length === 0
  })

  return { errorMessages, setBlurred, isValid }
}
